/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Report_Records_MetaInputs */

const en_us2_progress_report_records_meta = /** @type {(inputs: Progress_Report_Records_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimated 1RM above every earlier one`)
};

const pt_br2_progress_report_records_meta = /** @type {(inputs: Progress_Report_Records_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1RM estimado acima de todos os anteriores`)
};

const es_419_progress_report_records_meta = /** @type {(inputs: Progress_Report_Records_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1RM estimado por encima de todos los anteriores`)
};

const pt_pt2_progress_report_records_meta = /** @type {(inputs: Progress_Report_Records_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1RM estimado acima de todos os anteriores`)
};

const fr_fr2_progress_report_records_meta = /** @type {(inputs: Progress_Report_Records_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1RM estimé supérieur à tous les précédents`)
};

const de_de2_progress_report_records_meta = /** @type {(inputs: Progress_Report_Records_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geschätztes 1RM über allen bisherigen`)
};

const it_it2_progress_report_records_meta = /** @type {(inputs: Progress_Report_Records_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1RM stimato superiore a tutti i precedenti`)
};

/**
* | output |
* | --- |
* | "Estimated 1RM above every earlier one" |
*
* @param {Progress_Report_Records_MetaInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_report_records_meta = /** @type {((inputs?: Progress_Report_Records_MetaInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Report_Records_MetaInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_report_records_meta(inputs)
	if (locale === "es-419") return es_419_progress_report_records_meta(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_report_records_meta(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_report_records_meta(inputs)
	if (locale === "de-DE") return de_de2_progress_report_records_meta(inputs)
	if (locale === "it-IT") return it_it2_progress_report_records_meta(inputs)
	return en_us2_progress_report_records_meta(inputs)
});
export { progress_report_records_meta as "progress-report.records_meta" }